<template>
  <RightSideBar 
    button-class="bg-dynamicBackBtn text-white" 
    submit="Close" 
    cancel=""
    @submit="$emit('close')"
    :width="`34.5rem`"
  >
    <template v-slot:title>
      <div class="text-darkPurple font-bold text-lg"> 
        Approval Response
      </div>
    </template>
    <p class="text-sm font-normal text-shinyBlack mt-4">
        Track the status of this approval here. See who has approved and who is yet to approve.
    </p>
    <div class="mt-10 w-full">
      <div v-for="(approval, index) in approvalTrail" :key="index">
        <div class="w-full flex justify-between items-center gap-4 border-bottom py-4"
          :style="{ borderTop: index === 0 && `1px solid #0000001F` }"
        >
          <div class="flex justify-center items-center gap-3">
            <div>
              <img v-if="approval.photo" :src="approval.photo" alt="profile pic" class="w-8 h-8 rounded" />
              <div v-else class="w-8 h-8 rounded text-blueCrayola border text-center font-semibold pt-2">
                {{ $getInitials(approval.name) }}
              </div>
            </div>
            <p class="text-darkPurple">{{ approval.name }}</p>
          </div>

          <div class="flex flex-col">
            <div class="flex justify-end items-end gap-1">
              <p class="uppercase font-bold text-xs"
                :style="{
                    color: approval.status === 'approved' ? `#13B56A` : `#EA3C53`
                  }"
              >
                {{ approval.status }}
              </p>
              <div>
                <icon icon-name="active-checked-icon" size="xs" v-if="approval.status === 'approved'"/>
                <icon icon-name="red-cancel-icon" size="xs" v-else />
              </div>
            </div>
             <p class="">
                {{ $DATEFORMAT(new Date(approval.date), "MMMM dd, yyyy") }}.
                {{ getLastUploadedTime(approval.date) }}
              </p>
          </div>
        </div>
      </div>
    </div>
  </RightSideBar>
</template>

<script>
export default {
  name: "ApprovalTrail",
  components: {
    RightSideBar: () => import("./RightSideBar"),
  },
  props: {
    approvalTrail: {
      type: Array,
      default: []
    },
  },
  data() {
    return {};
  },
  methods:{
    getLastUploadedTime(time){
      const date = new Date(time);
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'pm' : 'am';

      // Convert hours to 12-hour format
      hours = hours % 12 || 12;
      const formattedTime = `${hours}:${minutes}${ampm}`;
      return formattedTime
    },
  },
};
</script>

<style scoped>
.border-bottom{
  border-bottom: 1px solid #0000001F !important
}
</style>
